import { createSelector } from "reselect"
import { selectUserData } from "./UserDataSelectors"
import type UserRewardStore from "../_stores/UserRewardStore"
import Immutable from "immutable"

export const selectUnusedRewards = createSelector(
  [selectUserData], 
  userData => (userData.get('rewards') as Immutable.OrderedMap<string, UserRewardStore | undefined | null>)
    .filter(reward => reward !== undefined && reward !== null && !reward.get('used')),
  {
    memoizeOptions: {
      resultEqualityCheck: (a:Immutable.OrderedMap<string, UserRewardStore>, b:Immutable.OrderedMap<string, UserRewardStore>) => {
        return a === b || (
          a instanceof Immutable.OrderedMap
          && b instanceof Immutable.OrderedMap
          && a.count() === b.count() 
          && a.every((reward,key) => reward.equals(b.get(key)))
        )
      }
    }
  }
)
